import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

interface IHouseSearchSidebarLayout {
  isMap?: boolean
  map?: React.ReactNode
  filters?: React.ReactNode[]
  filtersContainerClassName?: string
}

export const HouseSearchSidebarLayout = ({
  map,
  filters,
  filtersContainerClassName,
  isMap = false,
}: IHouseSearchSidebarLayout) => {
  return (
    <>
      {map && <div className={s.mapContainer}>{map}</div>}
      {filters && (
        <div
          className={clsx(s.filtersContainer, filtersContainerClassName, {
            [s.displayNone]: isMap,
          })}
        >
          {filters.map((filter, index) => {
            return (
              <div key={index} className={s.filterSegment}>
                <div key={index} className={s.filterSegmentContent}>
                  {filter}
                </div>
              </div>
            )
          })}
        </div>
      )}
    </>
  )
}
